import { z } from "zod";
import { domainSourceGroupSchema, overviewFilterSchema, topDomainSchema, } from "./overview.js";
/**
 * Every site in one part of the domain-sources ring, a page at a time.
 *
 * The Overview carries the ten most-cited sites; a part can hold far more.
 * Pressing a part on the card asks for its whole list here, placed by the same
 * query as the ring, so a site cannot sit in one part on the ring and another
 * in the list.
 */
/** Rows per page. The card shows them in a table, so the server pages it. */
export const DOMAIN_SOURCE_SITES_PAGE = 50;
export const domainSourceSitesQuerySchema = overviewFilterSchema.extend({
    group: domainSourceGroupSchema,
    offset: z.coerce.number().int().min(0).max(100_000).default(0),
});
export const domainSourceSitesSchema = z.object({
    group: domainSourceGroupSchema,
    /** How many different sites this part holds in the range: the legend's "N sites". */
    total: z.number().int().min(0),
    /** Most-cited first, then by name, from `offset`. */
    sites: z.array(topDomainSchema),
    /** Where the next page starts, or null when this one was the last. */
    nextOffset: z.number().int().min(0).nullable(),
});
/**
 * Every site cited in range, placed as the ring places it, with the engines
 * whose answers cited it: the Sources screen's Sites tab. Rust only. The
 * screen lists every cited page, so it lists every site; no paging.
 */
export const citedSiteSchema = topDomainSchema.extend({
    /** Engine ids, distinct, alphabetical. */
    engines: z.array(z.string()),
});
export const citedSitesSchema = z.object({
    reportId: z.string(),
    from: z.string(),
    to: z.string(),
    /** Most-cited first, then by name. */
    sites: z.array(citedSiteSchema),
});
//# sourceMappingURL=domain-source-sites.js.map